import { ILGPPreview, LGPPreview } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { LgpPreviewQuery } from "./types";

import transformQuery from "./transformers/query-transformer";

export const disableClientRender = true;

export const setCustomAttributes = ({
  variables,
}: WidgetContext<LgpPreviewQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<LgpPreviewQuery>): ILGPPreview => {
  return transformQuery(props);
}

const ResultsContainer = ({
  props,
  ...rest
}: WidgetContext<ILGPPreview>) => {
  log({ props, ...rest });

  return (
    <LGPPreview {...props} />
  );
}

export default ResultsContainer;